module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Colleagues', [_c('SearchBox', {
    attrs: {
      "placeholder": 'Type a name or email.',
      "value": _vm.name,
      "search": _vm.fetchColleagueSearchResults
    },
    on: {
      "update:value": function($event) {
        _vm.name = $event
      }
    }
  }), _vm._v(" "), (_vm.fetchingSearchResults) ? _c('Loader') : _c('ul', {
    staticClass: "mt-2"
  }, [_vm._l((_vm.results), function(user) {
    return _c('li', {
      staticClass: "d-flex align-items-center justify-content-between pb-2 pt-2 search-border flex-wrap"
    }, [_c('div', {
      staticClass: "d-flex justify-content-between align-items-center mb-1"
    }, [_c('img', {
      staticClass: "mr-2 br-1",
      attrs: {
        "src": user.avatar_url + '&size=48'
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "mr-2",
      attrs: {
        "title": user.email
      }
    }, [_vm._v(_vm._s(user.name || user.email)), _c('br'), _vm._v(" "), (user.school) ? _c('small', [_vm._v(_vm._s(user.school))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "d-flex justify-content-end grow-1"
    }, [(user.requested) ? _c('button', {
      staticClass: "button is-primary",
      attrs: {
        "disabled": "true"
      }
    }, [_vm._v("\n                Sent   \n          ")]) : _c('button', {
      staticClass: "button is-success",
      class: user.loading && 'is-loading',
      on: {
        "click": function($event) {
          _vm.sendColleagueRequest(user)
        }
      }
    }, [_vm._v("\n            Request\n          ")])])])
  }), _vm._v(" "), (_vm.initialState) ? _c('li', [_c('p', {
    staticClass: "text-center fs-5 text-muted mt-4"
  }, [_vm._v("Search for colleagues in your group.")])]) : (_vm.results.length === 0) ? _c('li', {
    staticClass: "text-center bold fs-5 text-muted"
  }, [_vm._v("\n        No results found.\n      ")]) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-7857677f"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FindColleagues.vue
// module id = 1068
// module chunks = 0